module.exports = __webpack_public_path__ + "27795970c50c438935bbf2d8070c30af.png";